import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const TermsOfService = () => (
  <LegalPageLayout
    eyebrow="Legal"
    title="Terms of Service"
    lead="Terms and conditions of use for the eCOMM Merchant Solutions website."
    lastUpdated="June 2026"
    testId="terms-of-service-page"
  >
    <p>
      These Terms and Conditions of Use govern your use of this Website. By using the eCOMM
      Merchant Solutions Limited ("EMS"), eCOMM Merchant Solutions Ireland Limited ("EMSIL")
      site, <a href="https://www.ecomm365.com">www.ecomm365.com</a>, you are deemed to have
      agreed to all terms, conditions, use and notices contained or referenced herein.
    </p>
    <p>
      EMS and EMSIL reserve the right, at their sole discretion, to change, modify, add or
      remove portions of these Terms of Use at any time. It is your responsibility to check the
      Terms & Conditions of Use periodically for changes. Your continued use of the Site
      following the posting of changes will mean that you accept and agree to the changes.
      Please note that separate terms and conditions may apply to specific products or services
      provided by EMS, EMSIL or their affiliated companies.
    </p>

    <h2>The Scope of Use</h2>
    <p>
      These Terms and Conditions of Use apply to your use of all sites and services owned or
      operated by EMS and EMSIL and affiliated companies. Unless we say otherwise, all
      references to EMS and EMSIL sites in these Terms and Conditions of Use include all such
      sites. These Terms and Conditions of Use do not apply to your use of unaffiliated sites to
      which any of the EMS and EMSIL sites only link. The information contained within this
      website is not for use within any country, jurisdiction or by any persons where such use
      would constitute a violation of law. If this applies to you, you are not authorised to
      access or use any of the information contained on this website.
    </p>
    <p>Please ensure that you have read and understood these terms and conditions before proceeding any further.</p>

    <h2>Terms of the Site in Use</h2>
    <p>
      The term "eCOMM", "eCOMM Merchant Solutions" or "us" or "we" refers to eCOMM Merchant
      Solutions Limited Ireland, the owner of the website. The term "you" refers to the user or
      viewer of our website.
    </p>

    <h2>Disclaimer</h2>
    <p>
      The information contained in this website is for information purposes only. Whilst every
      care has been taken in its preparation, we do not make any warranties or representations
      as to its completeness, accuracy or reliability. Although we have made all reasonable
      efforts to ensure that all of the information on the Website is accurate at the time of
      inclusion, we do not represent that this is the case and it should not be relied upon as
      such. We neither accept nor assume any responsibility to you in relation to the contents
      of this site.
    </p>
    <p>
      Access to and use of this Website is at your own risk and we do not represent or warrant
      the use of this website or any material downloaded from it will not cause damage to
      property, including but not limited to loss of data or computer virus infection. In no
      event do we accept liability of any description including liability for negligence for any
      damages whatsoever resulting from loss of use, data or profits arising out of or in
      connection with the access, use or performance of this website or any of its contents.
    </p>
    <p>
      This website contains material which is owned by or licensed to us. This material includes,
      but is not limited to, the design, layout, look, appearance, animation and graphics.
      Reproduction is prohibited other than in accordance with the copyright notice, which forms
      part of these Terms and Conditions of Use. All trademarks reproduced in this website,
      which are not the property of, or licensed to, EMS and EMSIL, are acknowledged on the
      website. Unauthorised use of this website may give rise to a claim for damages and/or be a
      criminal offence.
    </p>

    <h2>Links</h2>
    <p>
      We may include links to other websites or resources that are not part of EMS, EMSIL or
      affiliated companies to provide increased value to users of our websites. This access is
      at your sole discretion and risk. We are not responsible for the availability or content
      of any such sites or resources, and we do not endorse and shall not be responsible or
      liable, directly or indirectly, for the privacy practices of such websites, the content of
      these websites or resources or the use that others make of these websites or resources.
      You may not create a link to this website from another website or document without our
      prior written consent. You will need to make your own independent judgement regarding your
      interaction with these linked sites.
    </p>

    <h2>Website Session Data</h2>
    <p>
      By using the EMS & EMSIL website, you agree to allow EMS and EMSIL to record, from time to
      time, session data which may include referral source, IP address and/or website behaviour
      to provide you with the most relevant and personalised website experience.
    </p>

    <h2>Data Protection and Privacy</h2>
    <p>
      The <a href="/privacy-policy">Privacy Policy</a> that is applicable to this website is
      subject to these terms and conditions.
    </p>

    <h2>Copyright Notice</h2>
    <p>
      Copyright in this Website and the information set out on it belongs to us or our licensors
      and may not be copied, transmitted or reproduced without our prior consent. All copyright,
      trademark and other proprietary notices must be left intact. Save as otherwise specified,
      the contents of all the pages contained in this Website are copyright of EMS, EMSIL or its
      affiliates.
    </p>
    <ol>
      <li>
        Reproduction of part or all of the contents of the pages in any form is prohibited other
        than in accordance with the following permissions. You are granted a non-exclusive,
        non-transferable licence solely for the purpose of using this Website and any services
        available on this Website. You may make one electronically stored, transient copy of
        these pages for the exclusive purpose of on-line viewing. You may make one hard copy of
        these pages for exclusively, non-commercial purposes.
      </li>
      <li>
        Save where otherwise specified, the author(s) of the literary and artistic work set out
        in the pages contained in this Website have asserted their moral rights to be identified
        as the author of these works.
      </li>
      <li>
        This licence does not permit incorporation of the material or any part of it in any
        other work or publication, whether in hardcopy or electronic or any other form. In
        particular (but without limitation) no part of this website may be distributed or copied
        for any commercial purpose. No part of this website may be reproduced on or transmitted
        to or stored in any other website or other form of electronic retrieval.
      </li>
    </ol>

    <h3>Ireland (EMSIL)</h3>
    <p>
      The Copyright and Related Rights Act 2000 brought Irish legislation on intellectual
      property rights into line with current EU Directives. Copyright is a proprietary right
      which is established automatically and internationally; there is no system of registration
      for copyright protection in Ireland as copyright arises automatically on the creation of an
      original work.
    </p>

    <h3>United Kingdom (EMS)</h3>
    <p>
      The Copyright, Designs and Patents Act 1988 (as amended) is the current UK copyright law
      but it is important to note that it has been amended on a number of occasions since it came
      into force on 1 August 1989, and the amending laws have not been officially consolidated
      into a single text. Copyright is established automatically and there is no system of
      registration for copyright protection in the UK.
    </p>

    <h2>Liability</h2>
    <p>
      We do not accept liability for any inaccuracies or omissions on this site. All implied
      warranties are excluded to the fullest extent permissible under law. We reserve the right
      to update or alter the information on this website including these terms and conditions at
      any time without giving notice of the alterations. EMS and EMSIL do not give any warranty
      of uninterrupted use of this Website and EMS & EMSIL do not accept liability for any
      information posted on this Website by third parties.
    </p>
    <p>
      You will ensure that your use of this website complies with all applicable laws and
      regulations, including but not limited to those principles of law which protect against
      compromise of copyrights, trade secrets, proprietary information and other intellectual
      property rights, libel or defamation of character, invasion of privacy or tortious
      interference.
    </p>
    <p>
      No data transmission over the internet can be guaranteed as totally secure. Whilst we
      strive to protect such information we do not warrant and cannot ensure the security of any
      information which you transmit to us. Accordingly, any information which you transmit to us
      is transmitted at your own risk. Nevertheless, once we receive your transmission, we will
      take reasonable steps to preserve the security of such information in accordance with our
      Website Privacy Policy.
    </p>
    <p>You agree not to post or publish any offensive, defamatory or unlawful material that could encourage or constitute a criminal offence, civil liability or violation of any law.</p>
    <p>EMS and EMSIL reserve the right to monitor or review the contents of the Website but are not obliged to do so and assume no liability or responsibility for the contents therein.</p>
    <p>EMS and EMSIL reserve the right to remove any materials posted to the Website at their absolute discretion.</p>
    <p>You warrant that the information you enter on this website is accurate and you indemnify us in respect of any damage or legal costs arising out of any action taken against us in respect of the material posted by you.</p>

    <h2>Governing Law and Jurisdiction</h2>
    <p>
      These Terms and Conditions of Use and any disputes, claims or proceedings arising out of
      or in any way relating to these Terms and Conditions of Use shall be jointly governed by
      the laws of the United Kingdom and the Republic of Ireland. Either the English or the
      Irish courts shall have exclusive jurisdiction for the purpose of any proceedings arising
      out of or in any way relating to these Terms and Conditions of Use.
    </p>

    <h2>Acceptance of these Terms and Conditions of Use</h2>
    <p>
      By using the EMS, EMSIL sites, you acknowledge that you have read, understood and agree to
      be bound by the Terms and Conditions of Use. Please review the site's Terms and Conditions
      of Use, and if you do not agree to the terms therein, do not use our sites.
    </p>

    <h2>Warning Notice</h2>
    <p>
      ANY ATTEMPT BY ANY PERSON TO DAMAGE THIS WEBSITE OR UNDERMINE ITS OPERATION MAY BE A
      VIOLATION OF CRIMINAL OR CIVIL LAWS. EMS, EMSIL AND ANY OTHER AFFILIATED RELATED COMPANY
      RESERVE THE RIGHT TO SEEK DAMAGES FROM ANY SUCH PERSON TO THE FULL EXTENT OF THE LAW.
    </p>
    <p><em>The information contained in this website is subject to change without notice.</em></p>
  </LegalPageLayout>
);

export default TermsOfService;
